/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Nav_LabelInputs */

const en_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick tools navigation`)
};

const fr_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation QuickTools`)
};

const de_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellnavigation`)
};

const it_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigazione rapida degli strumenti`)
};

const ru_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрая навигация по инструментам`)
};

const es_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación rápida por herramientas`)
};

const zh_cn2_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速工具导航`)
};

const ja_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックツールナビゲーション`)
};

const hi_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्वरित उपकरण नेविगेशन`)
};

const pt_pt2_quicktools_nav_label = /** @type {(inputs: Quicktools_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação rápida de ferramentas`)
};

/**
* | output |
* | --- |
* | "Quick tools navigation" |
*
* @param {Quicktools_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_nav_label = /** @type {((inputs?: Quicktools_Nav_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Nav_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_nav_label(inputs)
	if (locale === "de") return de_quicktools_nav_label(inputs)
	if (locale === "it") return it_quicktools_nav_label(inputs)
	if (locale === "ru") return ru_quicktools_nav_label(inputs)
	if (locale === "es") return es_quicktools_nav_label(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_nav_label(inputs)
	if (locale === "ja") return ja_quicktools_nav_label(inputs)
	if (locale === "hi") return hi_quicktools_nav_label(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_nav_label(inputs)
	return en_quicktools_nav_label(inputs)
});